import React from "react";
import Group85 from "../Group85";
import "./Group822.css";

function Group822(props) {
  const { group85Props } = props;

  return (
    <div className="group-82-5">
      <Group85 path69={group85Props.path69} path70={group85Props.path70} className={group85Props.className} />
      <div className="projects-6 avenir-medium-black-18px">My Back Office</div>
    </div>
  );
}

export default Group822;
